'use client'

import React, { useEffect, useState } from 'react'
import { createContext, useContext } from 'use-context-selector'
import { BlankSite, LTC, SITES, TKR } from '@/config/site'
import { isLTC } from '@/config'
import {
  useCustomWebsiteFavicon,
  useCustomWebsiteTitle,
} from '@/fe-common/components/Topbar/hooks'

export type SiteContextValue = {
  name: string
  name_en: string
  company: string
  logo_cn: string
  show_name?: boolean
  isTrainkr?: boolean | undefined
  favicon?: string | undefined
  domains: string[]
}

const SiteContext = createContext<SiteContextValue>(BlankSite)

type ISiteProviderProps = {
  children: React.ReactNode
}

export const SiteProvider = ({ children }: ISiteProviderProps) => {
  const [site, setSite] = useState<SiteContextValue>(BlankSite)
  const customFavicon = useCustomWebsiteFavicon(isLTC)
  const title = useCustomWebsiteTitle()
  useEffect(() => {
    const hostname = globalThis.window.location.hostname
    const site = SITES.find(
      site =>
        site.domains.includes(hostname) ||
        site.domains.some(domain => hostname.endsWith(domain)),
    )
    setSite(site ?? (isLTC ? LTC : TKR))
  }, [])

  useEffect(() => {
    const link = document.querySelector('#favicon') as HTMLLinkElement
    if (customFavicon) {
      link.href = customFavicon
    } else {
      link.href = site.favicon ?? '/favicon.ico'
    }
    document.title = title || site.name
  }, [site, title, customFavicon])

  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>
}

export const useSiteContext = () => useContext(SiteContext)
